import React from "react";
import Navbar from "../global-components/navbar";
import Page_header from "../global-components/page-header";
import Footer from "../global-components/footer";
import { Helmet } from "react-helmet";
import OurPrivacy from "../section-components/our-Privacy";





const Privacy = () => {

    return (
        <div>
            {/* <Helmet>
                <title>Real Estate Services in Dubai | Trinest Sky – Off-Plan & Luxury Experts</title>
                <meta name="description" content="Explore expert real estate services in Dubai – from off-plan property sales and luxury homes to international investment advisory. Contact us today." />
            </Helmet> */}
            <Navbar />
            
            <Page_header headertitle="Privacy" />
           
            < OurPrivacy/>
            <Footer />
        </div>
    )
}

export default Privacy